import { useState } from 'react';
import { HeaderPage, Button } from 'components';
import { Divider, Form, message } from 'antd';
import {
  getDataTableSOAprobados,
  getDataTableBeneficiados,
  actualizarSujetosObligados
} from 'actions/identificacionSO.action';
import {
  useFiltersCandidatosAp,
  useFiltersBeneficiados
} from './components/hooks/useFiltersIdentificacionSO';
import * as payloads from './components/utilsIdentificacionSO/payloadsIdSO';
import { BuscadorSO } from './components/BuscadorSO';
import { ModalIdentificacionSO } from './components/ModalIdentificacionSO';
import { TableIdentificacionSO } from './components/TableIdentificacionSO';
import './IdentificacionSO.scss';

export const IdentificacionSO = () => {
  const [messageApi, contextHolder] = message.useMessage(null);
  const [dataSourceBeneficiados, setDataSourceBeneficiados] = useState([]);
  const [currentPageBeneficiados, setCurrentPageBeneficiados] = useState(1);
  const [dataSourceCandidatosAprobados, setDataSourceCandidatosAprobados] = useState([]);
  const [currentPageCandidatosAprobados, setCurrentPageCandidatosAprobados] = useState(1);
  const [currentSOSimac, setCurrentSOSimac] = useState('');
  const [currentIdSOAp, setCurrentIdSOAp] = useState(0);
  const [candidatoAprobadoChecked, setCandidatoAprobadoChecked] = useState({});
  const [totalBeneficiados, setTotalBeneficiados] = useState(0);
  const [totalCandidatosAprobados, setTotalCandidatosAprobados] = useState(0);
  const [loadingDataSources, setLoadingDataSources] = useState(false);
  const [openModalSO, setOpenModalSO] = useState(false);
  const [modalDescription, setModalDescription] = useState('info');
  const [filtersBeneficiadosTable, setFiltersBeneficiadosTable] = useFiltersBeneficiados([]);
  const [filtersCandidatosApTable, setFiltersCandidatosApTable] = useFiltersCandidatosAp([]);

  const [form] = Form.useForm();
  const initialPage = 1;
  const initialSizePage = 10;

  const errorMessagge = (content) => {
    return messageApi.open({ type: 'error', content });
  };

  /* ************************* Obtener datos para las tablas ************************* */

  const getDataTableIdBeneficiados = async (payload) => {
    try {
      setLoadingDataSources(true);
      const { success, response } = await getDataTableBeneficiados(payload);
      if (success && response.beneficiadosSimac) {
        const totalBenTemp = response.totalBeneficiadosSIMAC;
        setDataSourceBeneficiados(response.beneficiadosSimac);
        setTotalBeneficiados(totalBenTemp);
        if (totalBenTemp === 0) errorMessagge('No se encontraron Beneficiados');
      }
    } catch (error) {
      console.log('Error al obtener datdos de Beneficiados', error);
    } finally {
      setLoadingDataSources(false);
    }
  };

  const getDataTableSujetosAprobados = async (payload) => {
    try {
      setLoadingDataSources(true);
      const { success, response } = await getDataTableSOAprobados(payload);
      if (success && response.candidatosApSIF) {
        const totalCandTemp = response.totalCandidatosApSIF;
        setDataSourceCandidatosAprobados(response.candidatosApSIF);
        setTotalCandidatosAprobados(totalCandTemp);
        if (totalCandTemp === 0) errorMessagge('No se encontraron Sujetos Obligados Aprobados');
      }
    } catch (error) {
      console.log('Error al traer datos para la tabla de Sujetos Obligados Aprobados', error);
    } finally {
      setLoadingDataSources(false);
    }
  };

  const onSearchDataSources = async () => {
    try {
      const dataForm = await form.validateFields();
      setFiltersBeneficiadosTable([]);
      setFiltersCandidatosApTable([]);
      const dataFormTrurhy = Object.values(dataForm).every((value) => Boolean(value));
      if (dataFormTrurhy) {
        const sOSimac = dataForm.sujetoObligadoIdentificar.trim();
        const idSOAp = dataForm.idSujetoObligadoAprobados;
        setCurrentPageBeneficiados(initialPage);
        setCurrentPageCandidatosAprobados(initialPage);

        if (sOSimac !== currentSOSimac) {
          getDataTableIdBeneficiados(payloads.tableBeneficiados(dataForm));
          setCurrentSOSimac(dataForm.sujetoObligadoIdentificar);
        }

        if (idSOAp !== currentIdSOAp) {
          getDataTableSujetosAprobados(payloads.tableCandiatosAp(dataForm));
          setCurrentIdSOAp(idSOAp);
        }
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  /* ************************* Beneficiados ************************* */

  const onPageChangeBeneficiados = async (page, pageSize) => {
    setCurrentPageBeneficiados(page);
    const dataForm = await form.validateFields();
    const payload = payloads.filterTableBeneficiados(dataForm, filtersBeneficiadosTable);
    const { pagina, cantidad, ...restPayload } = payload;
    getDataTableIdBeneficiados({
      pagina: page,
      cantidad: pageSize,
      ...restPayload
    });
  };

  const onCheckChangeBeneficiados = (row, checked) => {
    setDataSourceBeneficiados((prev) => {
      return prev.map((item) =>
        item.idBeneficiado === row.idBeneficiado ? { ...item, selecciona: checked } : item
      );
    });
    if (checked) {
      const checkedSameTipoBeneficio =
        !dataSourceBeneficiados.filter(
          (beneficiado) =>
            beneficiado.selecciona === true &&
            beneficiado.idTipoBeneficio !== row.idTipoBeneficio &&
            beneficiado.idBeneficiado !== row.idBeneficiado
        ).length > 0;
      if (!checkedSameTipoBeneficio) {
        errorMessagge('Selecciona Beneficiados con el mismo Tipo de Beneficio');

        setDataSourceBeneficiados((prev) => {
          return prev.map((item) =>
            item.idBeneficiado === row.idBeneficiado ? { ...item, selecciona: false } : item
          );
        });
      }
    }
  };

  const handleFiltersBeneficiadosTable = (field, value) => {
    setFiltersBeneficiadosTable((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearchBeneficiados = async () => {
    const dataForm = await form.validateFields();
    const dataFormTruthy = Object.values(dataForm).every((value) => Boolean(value));
    if (dataFormTruthy) {
      const payload = payloads.filterTableBeneficiados(dataForm, filtersBeneficiadosTable);
      getDataTableIdBeneficiados(payload);
    }
  };

  /* ************************* Candidatos aprobados ************************* */

  const onPageChangeCandidatosAprobados = async (page, pageSize) => {
    setCurrentPageCandidatosAprobados(page);
    const dataForm = await form.validateFields();
    const payload = payloads.filterTableCandiatosAp(dataForm, filtersCandidatosApTable);
    const { pagina, cantidad, ...restPayload } = payload;
    getDataTableSujetosAprobados({
      pagina: page,
      cantidad: pageSize,
      ...restPayload
    });
  };

  const onCheckChangeCandidatosAprobados = (row, checked) => {
    setCandidatoAprobadoChecked({ ...row, asociar: checked });
    setDataSourceCandidatosAprobados((prev) => {
      return prev.map((item) =>
        item.idContabilidad === row.idContabilidad
          ? { ...item, asociar: checked }
          : { ...item, asociar: false }
      );
    });
  };

  const handleFiltersCandidatosAp = (field, value) => {
    setFiltersCandidatosApTable((prev) => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearchCandidatosAp = async () => {
    try {
      const dataForm = await form.validateFields();
      const dataFormTruthy = Object.values(dataForm).every((value) => Boolean(value));
      if (dataFormTruthy) {
        getDataTableSujetosAprobados(
          payloads.filterTableCandiatosAp(dataForm, filtersCandidatosApTable)
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* ************************* Actualizar Sujetos Obligados ************************* */

  const actualizarSO = async (payload) => {
    try {
      const { success, response } = await actualizarSujetosObligados(payload);
      if (success) {
        if (response.code === 200) {
          setModalDescription('correcto');
          onPageChangeBeneficiados(currentPageBeneficiados, initialSizePage);
          setDataSourceCandidatosAprobados((prev) => {
            return prev.map((item) => ({ ...item, asociar: false }));
          });
        }
        if (response.code !== 200) setModalDescription('error');
        setOpenModalSO(true);
      }
    } catch (error) {
      console.log('Error al actualizar el SO', error);
    }
  };

  const onCloseModalSO = () => {
    setOpenModalSO(false);
    setModalDescription('info');
  };

  const verifyChecked = () => {
    const relacionarBeneficiados = dataSourceBeneficiados.filter(
      (beneficiado) => beneficiado.selecciona === true
    );
    const isSameCountry = !relacionarBeneficiados.some(
      (beneficiado) => beneficiado.idEstado !== candidatoAprobadoChecked.idEstado
    );

    if (relacionarBeneficiados.length === 0) errorMessagge('Selecciona al menos un Beneficiado');

    if (!candidatoAprobadoChecked.asociar) errorMessagge('Selecciona un Sujeto Obligado aprobado');

    if (relacionarBeneficiados.length > 0 && candidatoAprobadoChecked.asociar && !isSameCountry)
      errorMessagge(
        'Asegúrate de asociar Beneficiados de la misma entidad del Sujeto Obligado Aprobado'
      );

    const isAsociar =
      relacionarBeneficiados.length > 0 && candidatoAprobadoChecked.asociar && isSameCountry;
    if (isAsociar) setOpenModalSO(true);
  };

  const updateSO = async () => {
    try {
      onCloseModalSO();
      // Si Proceso es Intercampaña el IdContabilidad se pone a NULL
      const dataForm = await form.validateFields();
      const candidatoAprobadoCheckedFormat =
        dataForm && dataForm.idProcesoEspecifico === 4
          ? { ...candidatoAprobadoChecked, idContabilidad: null }
          : candidatoAprobadoChecked;

      actualizarSO(
        payloads.actualizarBeneficiado(dataSourceBeneficiados, candidatoAprobadoCheckedFormat)
      );
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const resetDataTableOnChangeBeneficiados = () => {
    setDataSourceBeneficiados([]);
    setCurrentSOSimac('');
    setTotalBeneficiados(0);
  };

  const resetDataTableOnChangeCandidatos = () => {
    setDataSourceCandidatosAprobados([]);
    setCurrentIdSOAp(0);
    setTotalCandidatosAprobados(0);
  };

  const onClearBuscadorSO = () => {
    resetDataTableOnChangeBeneficiados();
    resetDataTableOnChangeCandidatos();
    setFiltersCandidatosApTable([]);
    setFiltersBeneficiadosTable([]);
    form.resetFields();
  };

  const tableControlsBeneficiados = {
    dataSource: dataSourceBeneficiados,
    onPageChange: onPageChangeBeneficiados,
    currentPage: currentPageBeneficiados,
    onCheckChange: onCheckChangeBeneficiados,
    total: totalBeneficiados,
    loading: loadingDataSources,
    onFilterChange: handleFiltersBeneficiadosTable,
    filters: filtersBeneficiadosTable,
    onEnterPress: handleSearchBeneficiados
  };

  const tableControlsCandidatosAprobados = {
    dataSource: dataSourceCandidatosAprobados,
    onPageChange: onPageChangeCandidatosAprobados,
    currentPage: currentPageCandidatosAprobados,
    onCheckChange: onCheckChangeCandidatosAprobados,
    total: totalCandidatosAprobados,
    loading: loadingDataSources,
    onFilterChange: handleFiltersCandidatosAp,
    filters: filtersCandidatosApTable,
    onEnterPress: handleSearchCandidatosAp
  };

  return (
    <div className="identificacion-so-container">
      {contextHolder}
      <HeaderPage
        section2="Identificación de Sujetos Obligados"
        title="Identificación de Sujetos Obligados"
        header="Asocia el ID del SO a los Beneficiados que fueron capturados manualmente."
      />
      <div className="buscador-table-container">
        <BuscadorSO
          form={form}
          onClear={onClearBuscadorSO}
          onSearchDataSources={onSearchDataSources}
          resetDataBeneficiados={resetDataTableOnChangeBeneficiados}
          resetDataCandidatosAp={resetDataTableOnChangeCandidatos}
        />
        <TableIdentificacionSO
          tableControls={tableControlsBeneficiados}
          headerTable="Beneficiados"
        />
        <Divider className="divider-id-so" />
        <TableIdentificacionSO
          tableControls={tableControlsCandidatosAprobados}
          headerTable="Aprobados"
        />
      </div>
      <div className="boton-actualizar-so">
        <Button
          text="Asociar"
          type="primary"
          disabled={dataSourceBeneficiados?.length === 0 || dataSourceCandidatosAprobados === 0}
          onClick={verifyChecked}
        />
      </div>
      <div>
        <ModalIdentificacionSO
          open={openModalSO}
          onClose={onCloseModalSO}
          description={modalDescription}
          updateSO={updateSO}
        />
      </div>
    </div>
  );
};
